import { useEffect } from 'react';

export default function Meta({ title, description }) {
  useEffect(() => {
    // Set Title
    if (title === 'Forside' || !title) {
      document.title = 'Energimæglere.dk';
    } else {
      document.title = `${title} - Energimæglere.dk`;
    }

    // Set Meta Description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    
    const defaultDesc = 'Uvildig energirådgivning og strategisk energiindkøb til erhverv. Vi optimerer jeres elaftaler gennem udbud, porteføljestyring og skræddersyede strategier.';
    metaDescription.setAttribute('content', description || defaultDesc);
  }, [title, description]);

  return null;
}
